const AuthQuote = () => (
  <div className="w-full hidden p-20 bg-[#111928] lg:flex items-center justify-center flex-col">
    <div className="hidden text-center max-w-[350px] lg:block">
      <img className="mx-auto mb-10 w-14" src="/auth/quotes.png" alt="" />
      <div className="text-white mb-4 text-lg">
        Ironpipeline brought our sales process into one place—our team can manage the pipeline and make calls without switching tools. That’s been a game changer for efficiency and consistency.
      </div>
      <img className="mx-auto mb-10" src="/auth/stars.png" />

      <div className="flex gap-3">
        <img src="/auth/tk.png" alt="TK" />
        <div className="flex flex-col text-left">
          <p className="text-[#ACB8C3] font-bold text-2xl">Terry Kim</p>
          <span className="text-[#ACB8C3] text-sm italic">CEO & Founder @ NGT Academy</span>
        </div>
      </div>
    </div>
  </div>
);

export default AuthQuote;
